import { type ClassNameValue, extendTailwindMerge } from 'tailwind-merge'

const customTailwindMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      'font-family': [
        {
          font: ['body', 'snpro', 'gelica', 'memoirs', 'bai-jamjoure', 'ghost', 'mono']
        }
      ]
    }
  }
})

function resolveTailwindClasses(...classesAttrs: ClassNameValue[]) {
  return customTailwindMerge(...classesAttrs)
}

export default resolveTailwindClasses
